<div *ngIf="!url" class="logo"></div>
<img *ngIf="url" class="logo" [src]="url" />
